@if (isTimeTrackingEnabled() && !task().isDone && !task().subTasks?.length) {
  @if (isCurrent()) {
    <button
      (click)="parent.pauseTask()"
      title="{{ T.F.TASK.CMP.TRACK_TIME_STOP | translate }} {{
        kb.togglePlay ? '[' + kb.togglePlay + ']' : ''
      }}"
      class="ico-btn"
      color="accent"
      mat-icon-button
    >
      <mat-icon>pause</mat-icon>
    </button>
  } @else {
    <button
      (click)="parent.startTask()"
      title="{{ T.F.TASK.CMP.TRACK_TIME | translate }} {{
        kb.togglePlay ? '[' + kb.togglePlay + ']' : ''
      }}"
      class="ico-btn start-task-btn"
      color=""
      mat-icon-button
    >
      <mat-icon class="play-icon">play_arrow</mat-icon>
    </button>
  }
}
@if (isShowAddToToday()) {
  <button
    (click)="parent.addToMyDay()"
    title="{{ T.F.TASK.CMP.ADD_TO_MY_DAY | translate }} {{
      kb.taskScheduleToday ? '[' + kb.taskScheduleToday + ']' : ''
    }}"
    class="ico-btn"
    color=""
    mat-icon-button
  >
    <mat-icon>wb_sunny</mat-icon>
  </button>
}
@if (isShowRemoveFromToday()) {
  <button
    (click)="parent.unschedule()"
    [title]="T.F.TASK.CMP.REMOVE_FROM_MY_DAY | translate"
    class="ico-btn"
    color=""
    mat-icon-button
  >
    <mat-icon>timer_off</mat-icon>
  </button>
}
@if (
  !task().notes && (!task().issueId || task().issueType === ICAL_TYPE) && !isSelected()
) {
  <button
    (click)="parent.toggleShowDetailPanel()"
    title="{{ T.F.TASK.CMP.TOGGLE_DETAIL_PANEL | translate }} {{
      kb.taskToggleDetailPanelOpen ? '[' + kb.taskToggleDetailPanelOpen + ']' : ''
    }}"
    class="ico-btn show-additional-info-btn"
    color=""
    mat-icon-button
  >
    @if (!task().issueWasUpdated) {
      <mat-icon>right_panel_open</mat-icon>
    }
    <!--            <mat-icon *ngIf="!task().issueWasUpdated">toc</mat-icon>-->
    <!--            <mat-icon *ngIf="!task().issueWasUpdated">chevron_right</mat-icon>-->
    @if (task().issueWasUpdated) {
      <mat-icon color="accent">update</mat-icon>
    }
  </button>
}
